import { useEffect, useRef } from "react";
import { authClient } from "@/lib/auth-client";
import posthog from "posthog-js";

export function PostHogIdentity() {
  const session = authClient.useSession();
  const identifiedUserId = useRef<string>();
  const user = session.data?.user;

  useEffect(() => {
    if (user) {
      if (identifiedUserId.current === user.id) return;

      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
      });
      identifiedUserId.current = user.id;
      return;
    }

    if (!session.isPending && identifiedUserId.current) {
      posthog.reset();
      identifiedUserId.current = undefined;
    }
  }, [session.isPending, user]);

  return null;
}
